import { render, staticRenderFns } from "./ExtensionStatusDataAnalysis.vue?vue&type=template&id=24414775&"
import script from "./ExtensionStatusDataAnalysis.vue?vue&type=script&lang=js&"
export * from "./ExtensionStatusDataAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports